import React, { useContext, useState } from 'react';
import { NewRequestContext } from '../context/NewRequestContext';
import { NewRequest } from '../pages/NewRequest';
import {
    useGetBranchByIdInRequestView as fetchBranchByIdInRequestView,
    useGetClientByCompanyName as fetchClientByCompanyName,
} from './clients-hooks';

/**
 * Отваря картона на обекта - същия диалог, който се отваря от Обекти и от маркер на картата, с данните за
 * обекта, клиента, плащането, фактурите, протоколите и устройствата.
 *
 * Стъпките са едни и същи навсякъде, откъдето се отваря, и точно затова стоят тук: обектът и клиентът се
 * теглят при натискане, а не предварително за целия списък, слагат се в {@link NewRequestContext} и се
 * записват в localStorage - таблицата с клиенти вътре в диалога чете `selectedClient` оттам при монтиране
 * и без него изчиства избора. Дотук същите пет реда стояха преписани в `BranchActionComponent`,
 * `Branches.tsx` и `MarkerInfoBox.tsx`.
 *
 * Грешките минават през глобалния интерцептор, който сам показва съобщение.
 */
export const useOpenBranchCard = () => {
    const { onClientSelect, onBranchSelect } = useContext(NewRequestContext);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const open = async (branchId?: number | null, companyName?: string | null) => {
        if (!branchId || !companyName) return;

        setLoading(true);
        try {
            const client = await fetchClientByCompanyName(companyName);
            const branch = await fetchBranchByIdInRequestView(branchId);

            onClientSelect(client);
            onBranchSelect(branch);
            setShowModal(true);
            localStorage.setItem('isModalOpen', JSON.stringify(true));
            localStorage.setItem('selectedClient', JSON.stringify(client));
        } finally {
            setLoading(false);
        }
    };

    const branchCard = showModal ? <NewRequest showModal={showModal} setShowModal={setShowModal} /> : null;

    return { open, loading, branchCard };
};
